import url from './url';

async function handleCursos(token) {

    try {
        let response = await fetch(`${url}/curso`, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            },
            method: 'get'
        });

        if (response.status === 401) {
            throw new Error('Unauthorized'); 
        }

        let data = await response.json();
        return data;
    } catch (error) {
        throw error; 
    }

}

async function showCurso(token, id) {

    let data = await fetch(`${url}/curso/${id}`, {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        },
        method: 'get'
    }).then(res => res.json());

    return data;

}

async function getCursosByMateria(token, materia_fk) {

    let data = await fetch(`${url}/curso/list/${materia_fk}`, {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        },
        method: 'get'
    }).then(res => res.json());

    return data;

}

export { handleCursos, showCurso, getCursosByMateria }